import React, { useCallback } from "react"
import { toast } from "react-hot-toast"
import Notification, { NotificationTypes } from "../components/fundamentals/notification"


// RAG-65 : la fonction renvoyée est mémorisée (useCallback) pour garder une
// référence STABLE entre deux rendus. Sinon, tout useEffect qui la liste dans
// ses dépendances (ex. l'écran du coefficient Plateforme) se relançait à chaque
// rendu — y compris pendant un enregistrement — et réaffichait l'ancienne valeur.
const useNotification = () => {
  return useCallback(
    (title: string, message: string, type: NotificationTypes) => {
      toast.custom(
        (t) => (
          <Notification toast={t} type={type} title={title} message={message} />
        ),
        {
          position: "top-right",
          duration: 3000,
        }
      )
    },
    []
  )
}

export default useNotification
